export const getBackToUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);

    const backToUrl = urlParams.get('backto');

    return backToUrl ? decodeURIComponent(backToUrl) : null;
}
